import React from 'react';
import PropTypes from 'prop-types';
import Modal from '@deporvillage/modal-component';
import ProductSlider from '@deporvillage/product-slider-component';
import { I18n } from '@deporvillage/utils-library-component';

import styles from './OutOfStockModal.module.scss';

const ProductSliderBreakpoints = {
    0: {
        slidesPerView: 2.5,
        slidesPerGroup: 1,
        spaceBetween: 1,
        freeMode: true,
    },
    575: {
        slidesPerView: 3.5,
        slidesPerGroup: 1,
        spaceBetween: 1,
        freeMode: true,
    },
    1034: {
        slidesPerView: 4,
        slidesPerGroup: 2,
        spaceBetween: 0,
        freeMode: true,
    },
};

const OutOfStockModal = ({ items, onClose }) => items?.length && (
    <div className={styles['out-of-stock-modal-component']}>
        <Modal
            onClose={() => onClose && onClose()}
        >
            <div className={styles.wrapper}>
                <div className={styles.title}>
                    <I18n>product_page.out_of_stock_popup.title</I18n>
                </div>

                <div className={styles.text}>
                    <I18n>product_page.out_of_stock_popup.subtitle</I18n>
                </div>

                <div className={styles.items}>
                    <ProductSlider
                        items={items.map((i, idx) => ({ ...i, url: `${i.url}?opt=popup_pdp_${idx + 1}` }))}
                        breakpoints={ProductSliderBreakpoints}
                        finite
                    />
                </div>

                <div className={styles.actions}>
                    <button
                        data-qa={'out-of-stock-modal-close-button'}
                        className={styles.button}
                        onClick={() => onClose && onClose()}
                    >
                        <I18n>product_page.out_of_stock_popup.cta</I18n>
                    </button>
                </div>
            </div>
        </Modal>
    </div>
);

OutOfStockModal.propTypes = {
    items: PropTypes.array,
    onClose: PropTypes.func,
};

export default OutOfStockModal;
